/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyMatchBypass = {
  properties: {
    cpf: {
      type: 'string',
    },
    cnpj: {
      type: 'string',
    },
  },
} as const;
